import React, { FC } from 'react';
import { TableBody, TableCell } from "@mui/material";
import { ProjectResponse } from '@api//projects/mutations';
import { EmptyRow, RenderRow } from '@components/create-project/table/helpers';
import { useTranslation } from 'react-i18next';

interface FinancialsTableProps {
  offer: ProjectResponse;
}

export const FinancialsTable: FC<FinancialsTableProps> = ({ offer }) => {
  const { t } = useTranslation();

  return (
    <TableBody>
      <tr>
        <TableCell className="w-full bg-black" sx={{p: "1px 4px", color: "white"}} colSpan={5}>
          {t("project.table.financials.title")}
        </TableCell>
      </tr>
      <RenderRow
        offer={offer}
        label={t("project.table.financials.manualDscrAdjustments")}
        name={null}
        caseType="F"
        units=" "
        fontWeight={700}
      />
      <EmptyRow />
      <RenderRow
        offer={offer}
        label={t("project.table.financials.manualLoanTermAdjust")}
        name={null}
        caseType="F"
        fontWeight={700}
        units=" "
      />
      <EmptyRow />
      <RenderRow
        offer={offer}
        label={t("project.table.financials.DSCR")}
        name="DSCR"
        caseType="F"
        units="x"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.financials.loanTerm")}
        name="Loan Term"
        caseType="F"
        units="years"
        sliceTo={0}
      />
      <EmptyRow />
      <RenderRow
        offer={offer}
        label={t("project.table.financials.freeCashflowMargin")}
        name="Free Cashflow Margin"
        caseType="F"
        units="%"
        fontWeight={700}
      />
      <EmptyRow />
      <RenderRow
        offer={offer}
        label={t("project.table.financials.NPV")}
        name="NPV"
        caseType="F"
        units="EUR"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.financials.IRR")}
        name="IRR"
        caseType="F"
        units="%"
      />
    </TableBody>
  );
};
